export default __webpack_public_path__ + "static/media/Foto5.d98de34e.png";